import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Toast } from '@openng/optimus-ui/toast';

@Component({
  selector: 'ui-toast',
  imports: [Toast],
  standalone: true,
  template: `<p-toast [key]="key()" />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiToastComponent {
  key = input<string | undefined>(undefined);
}
